<template>
  <div class="badge-select">
    <v-sheet :light="true">
      <v-toolbar-title class="toolbar-title">Select your badge</v-toolbar-title>
      <base-grid
        :items="items"
        :selected="selected"
        :imageUrls="imageUrls"
        v-on:grid:badge:click="badgeSelected"
      ></base-grid>
    </v-sheet>
  </div>
</template>

<script>
import BaseGrid from "@/components/BaseGrid"
import Vue from "vue"

export default {
  components: {
    BaseGrid
  },
  created() {
    this.$store.dispatch("badges/loadBadges")
  },
  data: function() {
    return {
      selected: []
    }
  },
  computed: {
    items() {
      return this.$store.getters["badges/getBadges"]
    },
    imageUrls() {
      return this.items.map(el => el.url)
    }
  },
  methods: {
    badgeSelected(item) {
      let index = this.items.findIndex(el => el.id === item.id)
      if (!this.selected[index]) {
        for (let i = 0; i < this.items.length; i++) {
          Vue.set(this.selected, i, false)
        }
        Vue.set(this.selected, index, true)
        this.$emit("badge:select", this.items[index])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.toolbar-title {
  font-weight: 700;
  color: $orange;
  text-align: center;
}

div.badge-select {
  height: 500px;
  max-width: 500px;
  min-width: 300px;
  overflow: scroll;
}
</style>
